export default __webpack_public_path__ + "static/media/Walk (10).683266ff.png";